import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { WorkflowStepInterface } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { parameterPassingValidReturnTypes } from '../../../common/constants';
import { CustomOutputParamsService } from './custom-output-params.service';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'automata-custom-output-parameters',
  templateUrl: './custom-output-parameters.component.html',
  styleUrls: ['custom-output-parameters.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyAlertModule,
    MatExpansionModule,
  ],
})
export class CustomOutputParametersComponent implements OnInit {
  @Input({ required: true }) step: WorkflowStepInterface;
  @Input({ required: true }) descriptionText: string;
  @Input({ required: true }) sectionTitleText: string;

  dataTypes = parameterPassingValidReturnTypes;

  constructor(public customOutputParamsService: CustomOutputParamsService) {}

  ngOnInit(): void {
    this.customOutputParamsService.clear();
    if (this.step?.customOutputParameters) {
      this.step.customOutputParameters.forEach((param) =>
        this.customOutputParamsService.addReturnKeyValue(param.settings.id, param.settings.dataType),
      );
    } else {
      // start with an empty return value entry
      this.customOutputParamsService.addReturnKeyValue();
    }
  }
}
